export const GAME_REWARD_ANIMATION_EVENT = "qubs:game-reward-animation";
export const HARDCORE_GAUGE_ANIMATION_EVENT = "qubs:hardcore-gauge-animation";
export const FIRST_VIDEO_REWARD_ANIMATION_EVENT = "qubs:first-video-reward-animation";
export const FIRST_MOMENT_REWARD_ANIMATION_EVENT = "qubs:first-moment-reward-animation";

export const dispatchGameRewardAnimation = ({ gain }) => {
  if (typeof window === "undefined") return;

  window.dispatchEvent(
    new CustomEvent(GAME_REWARD_ANIMATION_EVENT, {
      detail: {
        gain: String(gain ?? ""),
      },
    })
  );
};

export const dispatchFirstVideoRewardAnimation = ({ gain }) => {
  if (typeof window === "undefined") return;

  window.dispatchEvent(
    new CustomEvent(FIRST_VIDEO_REWARD_ANIMATION_EVENT, {
      detail: {
        gain: String(gain ?? ""),
      },
    })
  );
};

export const dispatchFirstMomentRewardAnimation = ({ gain }) => {
  if (typeof window === "undefined") return;

  window.dispatchEvent(
    new CustomEvent(FIRST_MOMENT_REWARD_ANIMATION_EVENT, {
      detail: {
        gain: String(gain ?? ""),
      },
    })
  );
};

export const dispatchHardcoreGaugeAnimation = ({ gain }) => {
  if (typeof window === "undefined") return;

  window.dispatchEvent(
    new CustomEvent(HARDCORE_GAUGE_ANIMATION_EVENT, {
      detail: {
        gain: String(gain ?? ""),
      },
    })
  );
};
